import React from 'react';
import { Formik } from 'formik';
import { LoginForm } from 'stash/components/log-in/LogInComponents';
import {
	Text,
	PrimaryButton,
	Link,
	SmartLink,
	FormikTextInput,
	Box,
	Fieldset,
	Legend,
} from '@stashinvest/ui';
import * as validations from 'stash/utils/formValidations';
import * as Yup from 'yup';

const ResetPasswordExpiredInitial = {
	email: '',
};

const ResetPasswordExpiredValidation = Yup.object().shape({
	email: validations.yupEmailValidation(),
});

const ResetPasswordExpired = ({ onSubmit }) => {
	return (
		<Formik
			initialValues={ResetPasswordExpiredInitial}
			validationSchema={ResetPasswordExpiredValidation}
			onSubmit={(values, actions) => {
				onSubmit(values).catch((resp) => {
					actions.setFieldError('email', resp.message);
					actions.setSubmitting(false);
				});
			}}
		>
			{(formProps) => (
				<LoginForm>
					<Text.H1 size={3} mb="s">
						This password reset link has expired.
					</Text.H1>
					<Text mb="m">
						For security reasons, this link has expired. We can send you an
						email with a new password reset link.
					</Text>
					<Fieldset p="none">
						<Legend screenReaderOnly>
							Enter your email address to recover your Stash password.
						</Legend>
						<Box>
							<FormikTextInput
								type="email"
								name="email"
								placeholder="email@example.com"
								label="What's your email address?"
							/>
						</Box>
						<Box mb="m">
							<PrimaryButton
								type="submit"
								disabled={formProps.isSubmitting}
								loading={formProps.isSubmitting}
							>
								<span>Send a new email</span>
							</PrimaryButton>
						</Box>
					</Fieldset>
					<Box>
						<Link
							as={SmartLink}
							href="https://ask.stash.com/"
							target="_blank"
							rel="noopener noreferrer"
						>
							Need help?
						</Link>
					</Box>
				</LoginForm>
			)}
		</Formik>
	);
};

export default ResetPasswordExpired;
